import { Toast } from '@kaleyra/emmy';
import { ApiMap, Instances } from '../../../../constants';
import { convertFilterToUrlParams } from '../../../../utils/storeUtility';
import i18n from '../../../../i18n/i18n';
import { setDownloadStatus } from '../../../../store/actions/download.action';
import store from "../../../../store/store";
import { apiBaseUrl, networkCall } from '../../../../utils/networkCall';

const getUrl = (
	instanceId: Instances,
	queryParams?: Record<string, any>,
	requestParams?: Record<string, any>
) => {
	const apiFn = ApiMap[instanceId];
	let url = apiFn;
	if (typeof apiFn === 'function') {
		url = (apiFn as Function)(requestParams);
	}

	const urlParams = new URLSearchParams();
	if (queryParams) {
		convertFilterToUrlParams(urlParams, queryParams);
	}
	urlParams.append('download', '1');



	return `${url}${url.includes('?') ? '&' : '/?'
		}${urlParams.toString()}`;
};

const getFileName = (disposition: string) => {
	if (disposition && disposition.indexOf('attachment') !== -1) {
		var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
		var matches = filenameRegex.exec(disposition);
		if (matches !== null && matches[1]) {
			return matches[1].replace(/['"]/g, '');
		}
	}
};


const downloadService = (
	instanceId: Instances,
	message: string,
	queryParams?: Record<string, any>,
	requestParams?: Record<string, any>
) => {

	networkCall('GET', getUrl(instanceId, queryParams, requestParams), apiBaseUrl.baseUrl, true, true, undefined, undefined,undefined, true)
		.then((response: any) => {
			const { data } = response;
			store.dispatch(setDownloadStatus(true));
			if (data?.code && data?.code === "E705") {
				Toast(i18n.t('downloadNoDataError'), 'error');
			} else {
				const fileName = getFileName(
					response.request.getResponseHeader('Content-Disposition')
				);
				if (fileName) {
					const url = window.URL.createObjectURL(
						new Blob([response.data])
					);
					const link = document.createElement('a');
					link.href = url;
					link.setAttribute('download', fileName);
					document.body.appendChild(link);
					link.click();
					document.body.removeChild(link);
					Toast(message, 'success');
				} else {
					Toast(i18n.t('downloadFailed'), 'error');
				}
			}
		})
		.catch((error) => {
			Toast(i18n.t('downloadFailed'), 'error');
			store.dispatch(setDownloadStatus(true));
		})
};

export default downloadService;